import React from 'react';

import { HASHTAG_PDF_EXPORTED_PREFIX } from '../../../utils/triviaResultsStrings';
import { formatPdfTimestamp } from '../../../utils/hashtagPdfExport';

const HashtagPdfDocument = ({ docRef, hashtagLabel, subtitle, extraLine, children }) => {
    return (
        <div className="uc-pdf-export-host" aria-hidden="true">
            <div className="uc-pdf-doc" ref={docRef}>
                <div className="uc-pdf-header">
                    <div className="uc-pdf-title">#{hashtagLabel}</div>
                    <div className="uc-pdf-subtitle">{subtitle}</div>
                    {extraLine ? <div className="uc-pdf-meta-line">{extraLine}</div> : null}
                    <div className="uc-pdf-meta-line">
                        {HASHTAG_PDF_EXPORTED_PREFIX} {formatPdfTimestamp(new Date())}
                    </div>
                </div>
                {children}
            </div>
        </div>
    );
};

export default HashtagPdfDocument;
